import React from 'react'
import PropTypes from 'prop-types'

import moment from 'moment'
import { connect } from 'react-redux'
import FlatButton from 'material-ui/FlatButton'
import { SearchBox } from 'react-instantsearch/dom'

import DateSelector from '../common/date/DateSelector'
import MiscUtils from '../infra/MiscUtils'
import DisplayModeSelector from './DisplayModeSelector'

const WEEK_START_TYPE = 'week'

class ScheduleToolbar extends React.Component {

  static propTypes = {
    userId: PropTypes.string.isRequired,
    dateStr: PropTypes.string.isRequired,
    viewMode: PropTypes.string,
    onTodayClicked: PropTypes.func.isRequired,
    onViewModeChanged: PropTypes.func.isRequired,
    onSearchReset: PropTypes.func.isRequired,
    onDateChanged: PropTypes.func.isRequired
  }

  getWeekFormat = (startDateStr, endDateStr) => {
    const startDate = moment(startDateStr)
    const endDate = moment(endDateStr)
    // Start showing the month of the startDate
    let startDateFormat = 'MMM D'
    let endDateFormat = ''
    // If they are from different months then show month from the endDate
    if (startDate.month() !== endDate.month()) {
      endDateFormat += 'MMM '
    }
    // Show day and year for the endDate
    endDateFormat += 'D, YYYY'
    // If they are from different years then show year from the startDate
    if (startDate.year() !== endDate.year()) {
      startDateFormat += ', YYYY'
    }
    return `${startDate.format(startDateFormat)} - ${endDate.format(endDateFormat)}`
  }

  getStartDateStr() {
    const dateObj = moment(this.props.dateStr)
    if (this.props.viewMode === 'week') {
      dateObj.startOf(WEEK_START_TYPE)
    }
    return dateObj.format('YYYY-MM-DD')
  }

  getEndDateStr() {
    return moment(this.getStartDateStr())
      .add(this.props.viewMode === 'week' ? 6 : 0, 'days')
      .format('YYYY-MM-DD')
  }

  handleAddJobClicked = () => {
    this.props.dispatch({
      type: 'UI_DIALOG',
      label: 'ADD_JOB',
      value: {
        dateStr: this.props.dateStr,
        workerId: this.props.userId,
        anchorButton: this.addJobButton
      }
    })
  }

  render() {
    return (
      <div
        style={styles.container}>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <DateSelector
            startDateStr={this.getStartDateStr()}
            endDateStr={this.getEndDateStr()}
            singleDay={this.props.viewMode !== 'week'}
            onDateChanged={this.props.onDateChanged}
            onTodayClicked={this.props.onTodayClicked} />
          <span
            style={{ fontSize: 13, marginLeft: 12, color: '#4a4a4a' }}>
            {
              this.props.viewMode !== 'week'
                ? moment(this.props.dateStr).format('dddd, MMM D, YYYY')
                : this.getWeekFormat(this.getStartDateStr(), this.getEndDateStr())
            }
          </span>
        </div>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <SearchBox
            searchAsYouType={false}
            onReset={this.props.onSearchReset} />
          {
            MiscUtils.STAGE === 'dev'
            &&
            <img style={{ marginLeft: 12 }} src="https://www.algolia.com/static_assets/images/pricing/pricing_new/algolia-powered-by-14773f38.svg"/>
          }
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <DisplayModeSelector
            viewMode={this.props.viewMode}
            onViewModeChanged={this.props.onViewModeChanged} />

          <FlatButton
            ref={addJobButton => this.addJobButton = addJobButton}
            style={styles.addEventButton}
            onTouchTap={this.handleAddJobClicked}>
            <div style={{ color: '#4d6f7f', fontWeight: 400 }}>+</div>
          </FlatButton>
        </div>
      </div>
    )
  }

}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    height: 48,
    flexShrink: 0,
    alignItems: 'center',
    paddingLeft: 18,
    paddingRight: 16,
    backgroundColor: '#f7f7f7',
    borderBottomStyle: 'solid',
    borderBottomWidth: 1,
    borderBottomColor: '#D3D3D3'
  },
  addEventButton: {
    height: 32,
    width: 32,
    minWidth: 32,
    marginLeft: 32,
    marginTop: 8,
    marginBottom: 8,
    borderRadius: 16,
    lineHeight: undefined,
    color: '#455559',
    border: 'solid 1px #bdbdbd'
  }
}

export default connect()(ScheduleToolbar)



// WEBPACK FOOTER //
// ./src/schedule/ScheduleToolbar.js